import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";
import {cacheManager} from "@/services/cacheManagerjs";

export const loadGenders = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    cacheManager.fetch('get/gender/enum', state.genders)
        .then((response) => {
          if(!response.fromState) commit(types.ADD_GENDERS, response.data)
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
  })
}

